export default __webpack_public_path__ + "static/media/entregado.941f925e.svg";